import { AppShell } from '@frontend/web-react';
import { concatClasses } from '@frontend/web-utils';
import type { AppShellMainProps } from '@mantine/core';

export type AppContentWrapperProps = AppShellMainProps & { children: React.ReactNode };

export const AppContentWrapper = ({ children, className }: AppContentWrapperProps) => (
  <AppShell.Main className={concatClasses(className, 'flex flex-col')}>{children}</AppShell.Main>
);
